import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
  pulse?: boolean;
}
export function CTAButton({
  children,
  onClick,
  size = 'default',
  className = '',
  pulse = true
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-8 py-4 md:px-10 md:py-5 text-lg md:text-2xl' : 'px-6 py-3 md:px-8 md:py-4 text-base md:text-xl';
  return <button onClick={onClick} className={`${pulse ? 'cta-pulse' : ''} bg-[#1A7C3E] hover:bg-[#156330] text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5 active:scale-[0.98] ${sizeClasses} ${className}`} data-id="element-354">
      {children}
    </button>;
}